import { addStyles } from 'ethcss'
import grid from 'blocks.simple/grid/grid.jcss'
import item from 'blocks.simple/item/item.jcss'
import { defaultThemeStyles } from '../index.theme'
import { colors, IStyles, palette } from '../../../../theme'

const ItemAdvertisingCampaignsStyles: IStyles = {
    wrapper() {
        return {
            ...grid.col,
            cursor: 'pointer',
            boxShadow: `var(--var-module-catalog-component-item-style-shadow, ${defaultThemeStyles.shadow})`,
            backgroundColor: `var(--var-module-catalog-component-item-style-idle, ${defaultThemeStyles.idle})`,
            overflow: 'hidden',
            [`&:hover .${this.checkWrapper}`]: {
                opacity: 1,
            },
        }
    },
    checkWrapper: {
        position: 'absolute',
        ...item.transitionErase,
        top: grid.p_microPlus.padding,
        right: grid.p_micro.padding,
        opacity: 0,
        zIndex: 2,
    },
    deviceStatus: {
        position: 'absolute',
        top: 4,
        left: 4,
        zIndex: 2,
        ...grid.rowCenter,
    },
    deviceStatusIcon: {
        ...grid.rowCenter,
        width: 22,
        height: 22,
        borderRadius: 4,
        backgroundColor: colors.white,
        boxShadow: `0 1px 3px ${palette.black[100]}`,
    },
    name: {
        ...grid.row,
        ...grid.normalCenter,
        padding: '10px 8px',
        ...item.blackOpacity,
        textTransform: 'uppercase',
        color: `var(--var-module-catalog-component-item-style-textMain, ${defaultThemeStyles.textMain})`,
        zIndex: 2,
        position: 'absolute',
        bottom: 0,
        width: '100%',
    },
    nameInner: {
        ...grid.space,
        ...grid.pr_mini,
        marginTop: 3,
        ...item.ellipsisPure,
    },
    preview: {
        ...item.abs,
        ...item.fullAbs,
        zIndex: 1,
        pointerEvents: 'none',
    },
    previewActive: {
        backgroundColor: palette.black[200],
    },
}

addStyles(ItemAdvertisingCampaignsStyles)
export default ItemAdvertisingCampaignsStyles
